import React, { Component } from 'react';
import { Card } from '@ecosystem/ui-lib/core/components/Card';
import { Table, GenericCell } from '@ecosystem/ui-lib/core/components/Table';
import { Input as EcoInput } from '@ecosystem/ui-lib/core/components/Input';
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import { Label } from 'app/components/Basics/';
import { QuotaFormContext } from '../../QuotaContext';
import _ from 'lodash';
import './TabQuotasComponent.scss';

class TabQuotas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorQuotaText: '',
            showQuotaModal: false,
            selectedQuestionSetQuotaToAdd: null,
            refreshRate: 30000
        };
        this.refreshInterval = null;
    }

    componentDidMount() {        
        this.setupRefreshInterval();   
    }

    componentWillUnmount() {
        // Clear the interval when component unmounts to prevent memory leaks
        this.clearRefreshInterval();
    }
    
    clearRefreshInterval() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
            this.refreshInterval = null;
        }
    }
    
    setupRefreshInterval() {
        this.clearRefreshInterval();
        if (this.state.refreshRate > 0) {
            this.refreshInterval = setInterval(() => {
                this.refreshQuotas();
            }, this.state.refreshRate);
        }
    }
    
    handleRefreshRateChange(selectedItem) {
        this.setState({ refreshRate: selectedItem.value }, () => {            
            this.setupRefreshInterval();
        });
    }
    
    refreshQuotas() {
        if (this.checkUserChangedQuotas() === false) {
            this.context.queryQuotas();
        }
    }

    getQuotasTableColumns() {
        const columns = [];
        columns.push({
            headerKey: `column-quotaname`,
            className: "AppFormTableHeader column-quotaname",
            name: `Quota Definition`
        });
        columns.push({
            headerKey: `column-limit`,
            className: "AppFormTableHeader column-limit",
            name: `Limit`
        });
        columns.push({
            headerKey: `column-inprogress`,
            className: "AppFormTableHeader column-inprogress",
            name: `In Progress`
        });
        columns.push({
            headerKey: `column-completed`,
            className: "AppFormTableHeader column-completed",
            name: `Completed`
        });       
        return columns;
    }

    limitHandler(questionSet, quota, event) {
        var questionSetQuotas = this.context.questionSetQuotas;
        var selectedQuestionSet = questionSetQuotas.find(q => q.questionSetId === questionSet.questionSetId);
        var selectedQuota = selectedQuestionSet.quotas.find(q => q.id === quota.id);
        selectedQuota.limit = event.target.value ? parseInt(event.target.value) : undefined;
        this.context.updateQuestionSetQuotas(questionSetQuotas);
    }

    addQuotaRow(questionSet, quota) {
        const cols = [];
        cols.push(<GenericCell className="column-questionset" primary={quota.quotaDefinitionName} />);
        cols.push(<GenericCell className="column-limit" primary={
            <EcoInput 
                disabled={this.userCannotChangeData()}
                type="number" 
                value={quota.limit} 
                onChange={this.limitHandler.bind(this, questionSet, quota)}
                key={quota.id}
                id={quota.id}
            />
        } />);
        cols.push(<GenericCell className="column-inprogress" primary={quota.inProgress} />);
        cols.push(<GenericCell className="column-completed" primary={quota.completed} />);
        return cols;
    }

    userCannotChangeData() {
        return !this.props.canChangeData;
    }    

    getRefreshOptions() {
        return [
            { value: 0, label: 'Disabled' },
            { value: 5000, label: 'Every 5 seconds' },
            { value: 10000, label: 'Every 10 seconds' },
            { value: 15000, label: 'Every 15 seconds' },
            { value: 30000, label: 'Every 30 seconds' }
        ];
    }

    getSelectedRefreshOption() {		
        return this.getRefreshOptions().find(t=> t.value === this.state.refreshRate);
    }    

    checkUserChangedQuotas() {
        if (!this.context.questionSetQuotas || !this.context.questionSetQuotasOriginal) {            
            return false;
        }
        const propertyToIgnore = 'tempKey';        
        const quotas = this.context.questionSetQuotas.map(item => _.omit(item, propertyToIgnore));
        const quotasOriginal = this.context.questionSetQuotasOriginal.map(item => _.omit(item, propertyToIgnore));
        const result = !_.isEqual(quotas, quotasOriginal);        
        return result
    }

    completionLimitHandler(questionSet, event) {
        var questionSetQuotas = this.context.questionSetQuotas;
        var selectedQuestionSet = questionSetQuotas.find(q => q.questionSetId === questionSet.questionSetId);
        selectedQuestionSet.completionLimit = event.target.value ? parseInt(event.target.value) : undefined;       
        this.context.updateQuestionSetQuotas(questionSetQuotas);
    }

    render() {
        return (
            <div className="TabQuotaQuotasComponent content-box">
                <div className="form-row">
					<div className="form-row-left">                    
                        {this.checkUserChangedQuotas() && (<p className='msgRefreshDisabled'>Auto refresh is disabled until you save your changes.</p>)}
                    </div>
					<div className="form-row-right auto-refresh-quotas">						
                        <Label>Auto Refresh Live Quotas:</Label>
                        <Select
                            id="refresh-rate"
                            value={this.getSelectedRefreshOption()}
                            onChange={val=>{
                                this.handleRefreshRateChange(val)                                
                            }}                                
                            options={this.getRefreshOptions()}
                            isDisabled={this.checkUserChangedQuotas() === true}                            
                            style={{ width: '150px' }}
                        />
					</div>
				</div>
                {this.context.questionSetQuotas && this.context.questionSetQuotas.length > 0 ? (
                    this.context.questionSetQuotas.map(questionSet => {
                        const rows = [];
                        const highlightedRows = [];
                        questionSet.quotas.forEach((quota, index) => {
                            rows.push(this.addQuotaRow(questionSet, quota));
                            if (quota.isFulfilled) {
                                highlightedRows.push(index+1);
                            }
                        });

                        return (
                            <Card key={questionSet.questionSetId}>
                                <h3>Question Set: {questionSet.questionSetName} {(questionSet.highPrio === 1) && (<span className="high-prio">(High Prio)</span>)}</h3> 
                                <div className="form-row">
                                    <div className="form-row-left questionset-quotas">
                                        <div className="field-limit-label">Completion Limit:</div>
                                        <div className="field-limit-text"> 
                                            <EcoInput 
                                                disabled={this.userCannotChangeData()}
                                                type="number" 
                                                value={questionSet.completionLimit} 
                                                onChange={this.completionLimitHandler.bind(this, questionSet)}
                                                key={questionSet.questionSetId}
                                                id={questionSet.questionSetId}
                                                />
                                        </div>
                                        <div className="field-progress">In Progress: {questionSet.inProgress}</div>
                                        <div className="field-completed">Completed: {questionSet.completed}</div>
                                        <div className={`field-status ${questionSet.questionSetStatus === 'Active' ? 'green' : ''}`}>Status: <span className={`${questionSet.questionSetStatus === 'Active' ? 'green' : ''}`}>{questionSet.questionSetStatus}</span></div>
                                    </div>
                                </div>
                                <Table
                                    className="QuotaList"
                                    columns={this.getQuotasTableColumns()}
                                    rows={rows}
                                    sortingOptions={{ headerKey: null }}
                                    isHeaderSticky={false}
                                    isFirstColumnSticky={false}
                                    highlightedRows={highlightedRows}
                                />
                            </Card>
                        );
                    })
                ) : (
                    <Card>
                        <div>
                            <p className='EmptyQuotaListInfoTitle'>Quotas list is empty</p>                            
                        </div>
                    </Card>
                )}
            </div>
        );
    }
}

TabQuotas.contextType = QuotaFormContext;
export default TabQuotas;